'use client';

import HomeHero, { type HomeHeroProps } from '@/components/HomeHero';
import HomeMobileSearch from '@/components/HomeMobileSearch';

export type HomeHeroSectionProps = HomeHeroProps;

export default function HomeHeroSection({
  title,
  subtitle,
  trackingSource,
}: HomeHeroSectionProps) {
  return (
    <>
      <HomeHero title={title} subtitle={subtitle} trackingSource={trackingSource} />
      <HomeMobileSearch
        trackingSource={trackingSource ? `${trackingSource}_mobile_search` : undefined}
      />
    </>
  );
}
